<template lang="pug">

  div

    v-dialog(v-model="showTimesheetModal" max-width="550px" :persistent="isLoadingGroupUsers === true || buildingReport === true")

      .dialogHeader

        .dialogHeaderTitle
          | Registro de check-in/check-out

        .dialogHeaderClose
          .dialogCloseButton.mdi.mdi-close(@click="close()")

      .dialogBody

        .dialogBodyContent(v-if="isLoadingGroupUsers")

          .dialogLoader
            .dialogLoaderInner
              .dialogLoaderCircle
              span.dialogLoaderText {{ loadingMessage }}

        .dialogBodyContent(v-else)


          .modalTimesheetField.mb-4
            label.csLabel
              span(v-html="'Selecione o mês e ano'")
            .csFields.csFields--date
              date-picker(v-model="dateRange" @change="onDateChange" :clearable="false" :disabled-date="disableDatesCondition" range valueType="format" format="DD/MM/YYYY" :lang="lang" class="fieldTimesheetMonthYear" :disabled="buildingReport")


          .modalTimesheetField.mb-6(v-if="users.length === 0")
            span.err
              | Nenhum profissional foi encontrado nesse período.

          .modalTimesheetField.mb-6(v-else)
            sos-checkbox(v-if="users.length > 1" id="todos" label="" @click="onAllCheckboxClick" :checked="checkboxAllUsers" :disabled="buildingReport").modalTimesheetGenerateButton

            label.csLabel
              span {{ users.length === 1 ? 'Selecione o usuário' : 'Selecione os usuários' }}
            .csFields
              users-list-component(:users="users" @click="onClickUser")


          .modalTimesheetField.mb-6(v-if="users.length > 0 && availableScales.length > 0")
            label.csLabel.mb-2
              span Escalas do Relatório
            .csFields
              .scale-selection-display(@click="openScalesSelection" :class="{ 'is-disabled': buildingReport, 'is-empty': selectedScales.length === 0 }")
                .scale-names-container
                  span.empty-scales-text(v-if="selectedScales.length === 0") Nenhuma escala selecionada
                  template(v-else)
                    span.scale-name(v-for="(scale, index) in displayedScalesNames" :key="scale.scaleID")
                      | {{ scale.scaleName }}
                      span.separator(v-if="index < displayedScalesNames.length - 1") ,
                    span.more-scales(v-if="hasMoreScales")  +{{ remainingScalesCount }} mais
                    span.all-scales-text(v-if="allScalesSelected && availableScales.length > 1")  (Todas)
                .scale-selection-icon
                  i.mdi.mdi-chevron-down


          .modalTimesheetField.mb-5(v-if="users.length > 0")
            label.csLabel.mb-2
              span(v-html="'Opções'")
            .csFields
              sos-checkbox(id="mostrar_valor_hora" label="Exibir Valor hora" @click="onShowHourlyRateClick" :checked="showHourlyRate" :disabled="buildingReport")
              sos-select(
                v-if="showHourlyRate"
                label="Tipo de valor por hora"
                :items="hourlyRateOptions"
                :default="selectedHourlyRateOption"
                @sosSelectChanged="onHourlyRateOptionChange"
                :disabled="buildingReport"
                defaultEmpty="Selecione uma opção"
              )

          .modalTimesheetField.mb-5(v-if="users.length > 0")
            label.csLabel
              span(v-html="'Formato do Relatório'")
            .csFields
              sos-select(
                label="Formato de exportação"
                :items="exportFormatOptions"
                :default="selectedExportFormat"
                @sosSelectChanged="onExportFormatChange"
                :disabled="buildingReport"
                defaultEmpty="Selecione um formato"
              )

          .modalTimesheetField.modalTimesheetField--columns.mb-5(v-if="users.length > 0")
            label.csLabel
              span(v-html="'Colunas do Relatório'")
            .csFields.csFields--columns-selection
              .column-group(v-for="group in allAvailableColumnGroups" :key="group.label")
                h4.column-group-title {{ group.label }}
                .column-checkbox-group
                  .column-checkbox(v-for="column in group.columns" :key="column.id")
                    sos-checkbox(
                      :id="column.id"
                      :label="column.label"
                      :checked="selectedColumns.includes(column.id)"
                      @click="toggleColumnSelection(column.id)"
                      :disabled="isColumnDisabled(column.id)"
                    )


          div(v-if="users.length > 4")
            .inline-block.footerLeft
              span.usersCount {{ users.length }} usuários
            .inline-block.footerRight
              sos-button(@buttonClick="generateTimesheet()" buttonLabel="Gerar" color="success" buttonIcon="mdi-arrow-right" iconPosition="right" buttonIconSize="15" size="medium" :loading="buildingReport" :disabled="selectedUsers.length === 0 || selectedColumns.length === 0 || selectedScales.length === 0")

          .text-right(v-else)
            sos-button(@buttonClick="generateTimesheet()" buttonLabel="Gerar" color="success" buttonIcon="mdi-arrow-right" iconPosition="right" buttonIconSize="15" size="medium" :loading="buildingReport" :disabled="selectedUsers.length === 0 || selectedColumns.length === 0 || selectedScales.length === 0")

    confirm-dialog(ref="cdConfirmModal" :title="cdParameters.title" :text="cdParameters.text" :buttonPosition="cdParameters.buttonPosition" :width="cdParameters.width" @close="cdMessageResponse")

    subscription-modal(:active="subscriptionModal.active" :titulo="subscriptionModal.title" :text="subscriptionModal.message" @close="closeSubscriptionModal")

    v-dialog(v-model="showScalesModal" max-width="500px")
      .dialogHeader
        .dialogHeaderTitle Selecionar Escalas
        .dialogHeaderClose
          .dialogCloseButton.mdi.mdi-close(@click="closeScalesModal()")
      .dialogBody
        .dialogBodyContent
          .scales-selection-container
            .scales-header
              sos-checkbox(id="all-scales" label="Selecionar todas" @click="toggleAllScales" :checked="allScalesSelected" :disabled="false")
            .scales-list
              .scale-item(v-for="scale in availableScales" :key="scale.scaleID")
                sos-checkbox(
                  :id="'scale_' + scale.scaleID"
                  :label="scale.scaleName"
                  :checked="selectedScales.includes(scale.scaleID)"
                  @click="toggleScale(scale.scaleID)"
                )
          .text-right.mt-4
            sos-button(@buttonClick="closeScalesModal()" buttonLabel="Confirmar" color="success" size="medium")

</template>

<script>

  import dateTimeLanguage from '@/constants/dateTimeLanguage'
  import { freeVersion } from '@/constants'
  import { apiCheckReportStatus, apiOpenReport, apiDownloadTimesheetPDF } from '@/services/report'
  import { getUserByID } from '@/services/firebase'

  import { isValidDate, parseDate } from '@/mixins/utils.js'
  import { apiGetGroupStatistics } from '@/services/duties'

  import UsersListComponent from '@/components/UsersListComponent'
  import SubscriptionModal from '@/modals/SubscriptionModal'
  import ConfirmDialog from '@/modals/ConfirmDialog'
  import SosButton from '@/components/SosButton'
  import SosCheckbox from '@/components/SosCheckbox'
  import SosSelect from '@/components/SosSelect'

  import {
    DUTY_VALUE_SOURCE_SCALE,
    DUTY_VALUE_SOURCE_USER_GROUP,
    DUTY_VALUE_SOURCE_USER_SCALE,
  } from "@/constants/dutyValueSources";

  import GroupMixin from '@/mixins/group.mixin'
  import UserMixin from '@/mixins/user.mixin'
  import SubscriptionModalMixin from '@/mixins/subscription.modal.mixin'
  import confirmDialogMixin from '@/mixins/cd.mixin.js'

  import { mapState } from 'vuex'

  import DatePicker from 'vue2-datepicker'
  import 'vue2-datepicker/index.css'

  import moment from 'moment'
  import 'moment/locale/pt-br'

  moment.locale('pt-BR')


  const buildSubscriptionModalContent = userSession => {
    const planName = userSession.planName.name

    const talkToOurSupport = `<a href="https://api.whatsapp.com/send?phone=5513992061010&text=Olá, estou no ${planName} e não consigo gerar o registro de check-in/check-out. Preciso de ajuda." target="_blank">suporte</a>`
    const textSupport = `<p>Por favor, verifique a situação do seu plano com o nosso ${talkToOurSupport}.</p>`

    if (userSession.planOrigin === 'CUSTOM') {
      return { title: 'Verifique seu plano', message: `<p>Você está no ${planName} personalizado, mas o registro de check-in/check-out não está liberado.</p>${textSupport}` }
    } else if (userSession.planOrigin === 'COUPON') {
      return { title: 'Verifique seu plano', message: `<p>Você tem um cupom ativo e está no ${planName}, mas o registro de check-in/check-out não está liberado.</p>${textSupport}` }
    } else if (userSession.planOrigin === 'VINDI' && userSession.vindi.paymentStatus === 'paid') {
      return { title: 'Faça um upgrade', message: `<p>Você está no ${planName}.</p><p>Para gerar o registro de check-in/check-out, assine o Plano Silver ou superior.</p><p>Para mais informações, converse o nosso ${talkToOurSupport}.</p>` }
    } else if (userSession.planOrigin === 'VINDI' && userSession.vindi.paymentStatus !== 'paid') {
      return { title: 'Verifique sua assinatura', message: `<p>Você é assinante do ${planName}, mas ele não está ativo e o registro de check-in/check-out não está liberado.</p>${textSupport}` }
    } else {
      if (!!userSession.vindi === true) {
        return { title: 'Verifique sua assinatura', message: `<p>Você assinou o ${userSession.vindi.planName.name}, mas ele expirou.</p><p>Agora você está no ${planName} e o registro de check-in/check-out não está liberado.</p>${textSupport}` }
      } else {
        return { title: 'Verifique seu plano', message: `<p>Você está no ${planName} e o registro de check-in/check-out não está liberado.</p>${textSupport}` }
      }
    }
  }


  export default {
    name: 'ExportTimesheetModal',

    components: {
      UsersListComponent,
      SubscriptionModal,
      ConfirmDialog,
      'sos-checkbox': SosCheckbox,
      'sos-button': SosButton,
      'sos-select': SosSelect,

      'date-picker': DatePicker,
    },

    mixins: [
      GroupMixin,
      UserMixin,
      SubscriptionModalMixin,
      confirmDialogMixin,
    ],

    data () {
      return {
        showTimesheetModal: false,

        buildingReport: false,

        checkboxAllUsers: false,
        showHourlyRate: false,

        isLoadingGroupUsers: false,
        users: [],

        dateRange: [],
        changedDateRange: [],

        shouldAutoLoadUsers: false, // Desabilita o carregamento automático do UserMixin

        lang: dateTimeLanguage,

        allAvailableColumnGroups: [
          {
            label: 'Dados do Plantonista',
            columns: [
              { id: 'period', label: 'Período', defaultChecked: true },
              { id: 'groupName', label: 'Grupo', defaultChecked: true },
              { id: 'userName', label: 'Nome', defaultChecked: true },
              { id: 'userPhone', label: 'Telefone', defaultChecked: true },
              { id: 'userCRM', label: 'CRM', defaultChecked: true },
              { id: 'userCPF', label: 'CPF', defaultChecked: true },
              { id: 'userAccount', label: 'Dados Bancários', defaultChecked: true },
              { id: 'userEmail', label: 'E-mail', defaultChecked: true },
            ]
          },
          {
            label: 'Dados do Plantão',
            columns: [
              { id: 'data', label: 'Dia', defaultChecked: true },
              { id: 'escala', label: 'Escala', defaultChecked: true },
              { id: 'coordsEntry', label: 'Entrada (Coordenadas)', defaultChecked: true },
              { id: 'coordsExit', label: 'Saída (Coordenadas)', defaultChecked: true },
              { id: 'obsExit', label: 'Observação (Saída)', defaultChecked: true },
              { id: 'obsManager', label: 'Observação (Gestor)', defaultChecked: true },
              { id: 'plannedEntry', label: 'Entrada planejada', defaultChecked: true },
              { id: 'plannedExit', label: 'Saída planejada', defaultChecked: true },
              { id: 'plannedDuration', label: 'Duração planejada', defaultChecked: true },
              { id: 'actualEntry', label: 'Entrada', defaultChecked: true },
              { id: 'actualExit', label: 'Saída', defaultChecked: true },
              { id: 'totalDuration', label: 'Total (Duração)', defaultChecked: true },
              { id: 'totalDecimalDuration', label: 'Total (Duração decimal)', defaultChecked: true },
              { id: 'deviceEntry', label: 'Dispositivo (Entrada)', defaultChecked: true },
              { id: 'deviceExit', label: 'Dispositivo (Saída)', defaultChecked: true },
              { id: 'pauseEntry', label: 'Pausa (Entrada)', defaultChecked: true },
              { id: 'pauseExit', label: 'Pausa (Saída)', defaultChecked: true },
              { id: 'pauseDuration', label: 'Pausa (Duração)', defaultChecked: true },
            ]
          }
        ],
        selectedColumns: [],

        hourlyRateOptions: [
          { key: `base_${DUTY_VALUE_SOURCE_SCALE}`, value: DUTY_VALUE_SOURCE_SCALE, text: 'Valor hora da escala selecionada' },
          { key: `base_${DUTY_VALUE_SOURCE_USER_SCALE}`, value: DUTY_VALUE_SOURCE_USER_SCALE, text: 'Valor hora do usuário na escala selecionada' },
          { key: `base_${DUTY_VALUE_SOURCE_USER_GROUP}`, value: DUTY_VALUE_SOURCE_USER_GROUP, text: 'Valor hora do usuário no grupo' },
        ],
        selectedHourlyRateOption: DUTY_VALUE_SOURCE_SCALE,

        exportFormatOptions: [
          { key: 'excel', value: 'excel', text: 'Excel (.xlsx)' },
          { key: 'pdf', value: 'pdf', text: 'PDF (.pdf) Simples' },
          { key: 'pdf_plus', value: 'pdf_plus', text: 'PDF (.pdf) Detalhado' },
        ],
        selectedExportFormat: 'excel',

        showScalesModal: false,
        selectedScales: [],
      }
    },

    computed: {
      ...mapState({
        userSession: state => state.app.userSession,
        groupScales: state => state.app.groupScales,
      }),

      availableScales: function () {
        return !!this.groupScales === true && Array.isArray(this.groupScales) && this.groupScales.length > 0 ? this.groupScales : []
      },

      selectedScalesCount: function () {
        return this.selectedScales.length
      },

      allScalesSelected: function () {
        return this.availableScales.length > 0 && this.selectedScales.length === this.availableScales.length
      },

      displayedScalesNames: function () {
        // Mostra até 3 escalas no display
        const selectedScalesObjects = this.availableScales.filter(scale =>
          this.selectedScales.includes(scale.scaleID)
        )
        return selectedScalesObjects.slice(0, 3)
      },

      hasMoreScales: function () {
        return this.selectedScales.length > 3
      },

      remainingScalesCount: function () {
        return this.selectedScales.length - 3
      },

      loadingMessage: function () {
        return this.isLoadingGroupUsers ? 'Carregando usuários...' : (this.buildingReport ? 'Gerando registro...' : 'Carregando...')
      },

      selectedUsers: function () {
        return !!this.users === true && this.users.length > 0 ? this.users.filter(user => user.checked).map(user => user.uid) : []
      },
    },

    watch: {
      changedDateRange: {
        immediate: true,
        handler (newRange, oldRange)
        {
          if (
            !!this.groupID === true &&
            !!this.showTimesheetModal === true &&
            Array.isArray(newRange) &&
            newRange.length === 2 &&
            isValidDate(newRange[0]) &&
            isValidDate(newRange[1])
          ) {
            const firstDateObj = parseDate(newRange[0])
            const lastDateObject = parseDate(newRange[1])
            const differenceInDays = Math.floor((lastDateObject - firstDateObj) / (1000 * 60 * 60 * 24))

            if (differenceInDays > 62) {
              this.dateRange = oldRange
              this.showMessage('Atenção!', 'Você pode selecionar até dois meses')
            } else {
              this.loadGroupUsers(this.groupID, newRange[0], newRange[1])
            }
          }
        },
      },

      showTimesheetModal: {
        immediate: true,
        handler: function (showTimesheetModal, oldShowTimesheetModal)
        {
          if (oldShowTimesheetModal === true && showTimesheetModal === false) this.reset()
        },
      },

      availableScales: {
        immediate: true,
        handler: function (scales) {
          if (scales && scales.length > 0) {
            this.initializeSelectedScales();
          }
        },
      },
    },

    beforeDestroy () {
      this.clear()
    },

    created() {
      this.initializeSelectedColumns();
    },

    methods: {
      initializeSelectedColumns() {
        const defaultSelected = this.allAvailableColumnGroups.flatMap(group =>
          group.columns.filter(col => col.defaultChecked).map(col => col.id)
        );

        if (this.showHourlyRate && (this.selectedHourlyRateOption === 'scale' || this.selectedHourlyRateOption === 'user_scale' || this.selectedHourlyRateOption === 'user_group')) {
          if (!defaultSelected.includes('userHourlyRate')) defaultSelected.push('userHourlyRate');
          if (!defaultSelected.includes('payment')) defaultSelected.push('payment');
        }
        this.selectedColumns = defaultSelected;
      },


      disableDatesCondition (date, _)
      {
        return date < new Date(2016, 0, 1)
      },


      reset () {
        this.showTimesheetModal = false

        this.buildingReport = false

        this.checkboxAllUsers = false
        this.showHourlyRate = false

        this.isLoadingGroupUsers = false
        this.users = []

        this.dateRange = []
        this.changedDateRange = []

        this.initializeSelectedColumns();
        this.selectedExportFormat = 'excel';

        this.showScalesModal = false;

        this.cdParameters = { title: '', text: '', buttonPosition: 'right', width: 330 }
      },

      clear () {
        this.reset()

        delete this.showTimesheetModal

        delete this.buildingReport

        delete this.checkboxAllUsers
        delete this.showHourlyRate

        delete this.isLoadingGroupUsers
        delete this.users

        delete this.dateRange
        delete this.changedDateRange

        delete this.allAvailableColumnGroups
        delete this.selectedColumns

        delete this.exportFormatOptions
        delete this.selectedExportFormat

        delete this.cdParameters
      },



      async loadGroupUsers (groupID, firstDate, lastDate)
      {

        this.isLoadingGroupUsers = true

        const [firstDateDay, firstDateMonth, firstDateYear] = String(firstDate).split('/').map(Number)
        const [lastDateDay, lastDateMonth, lastDateYear] = String(lastDate).split('/').map(Number)

        const startOfMonth = moment.utc([firstDateYear, firstDateMonth - 1, firstDateDay, 0, 0, 0, 0]).startOf('day').unix() * 1000
        const endOfMonth = moment.utc([lastDateYear, lastDateMonth - 1, lastDateDay, 0, 0, 0, 0]).endOf('day').unix() * 1000

        const userKeys = []

        const shifts = await apiGetGroupStatistics(groupID, { start: startOfMonth, end: endOfMonth })

        if (shifts.length > 0)
        {
          shifts.forEach(([shiftID, shift]) => {
            if (
              !!shift === true &&

              !!shift.uid_pegou === true &&
              String(shift.uid_pegou).trim().length > 0 &&

              !!shift.data_inicio === true

            )
            {
              const userTime = !!shift.start_location === true && !!shift.end_location === true ? 'START_END' : (!!shift.start_location === true ? 'START' : false)

              const foundUserIndex = userKeys.findIndex(user => user.userID === String(shift.uid_pegou).trim())

              if (foundUserIndex !== -1)
              {
                if (
                  (userKeys[foundUserIndex].userTime === false && userTime !== false) ||
                  (userKeys[foundUserIndex].userTime === 'START' && userTime === 'START_END')
                ) {
                  userKeys[foundUserIndex].userTime = userTime
                }
              }
              else
              {
                userKeys.push({ userID: String(shift.uid_pegou).trim(), userTime })
              }
            }
          })
        }

        const usersList = userKeys.length > 0 ? await Promise.all(
          userKeys.map(async user => ({ ...user, ...await getUserByID(user.userID) })).filter(user => !!user === true && typeof user === 'object')
        ) : []

        if (usersList.length > 0) usersList.sort((a, b) => a.nome.localeCompare(b.nome))

        this.users = usersList.map(user => ({ ...user, checked: false }))

        this.checkboxAllUsers = false

        this.isLoadingGroupUsers = false


        localStorage.setItem(`@sosplantao_timesheet_${this.groupID}`, JSON.stringify({ firstDate, lastDate }))
      },


      onDateChange (dates)
      {

        this.changedDateRange = dates
      },


      goToPlanos () {
        this.$router.push('/admin/assinatura')
      },


      close ()
      {
        if (!!this.buildingReport || !!this.isLoadingGroupUsers) return false

        this.showTimesheetModal = false

      },


      open ()
      {

        if (freeVersion === false && this.userSession.userCapabilities.folhaDePonto !== true)
        {
          const subscriptionModalContent = buildSubscriptionModalContent(this.userSession)

          this.openSubscriptionModal(subscriptionModalContent.title, subscriptionModalContent.message)

          return false
        }


        let loadedFilter = null

        const filters = localStorage.getItem(`@sosplantao_timesheet_${this.groupID}`)

        if (!!filters === true) {
          try {
            loadedFilter = JSON.parse(filters)
          } catch (e) {
            localStorage.removeItem(`@sosplantao_timesheet_${this.groupID}`)
          }
        }


        moment.locale('pt-BR')

        const firstDate = !!loadedFilter === true && !!loadedFilter.firstDate === true ? (
          loadedFilter.firstDate
        ) : (
          moment().startOf('month').format('DD/MM/YYYY')
        )

        const lastDate = !!loadedFilter === true && !!loadedFilter.lastDate === true ? (
          loadedFilter.lastDate
        ) : (
          moment().endOf('month').format('DD/MM/YYYY')
        )

        this.dateRange = [firstDate, lastDate]
        this.changedDateRange = [firstDate, lastDate]



        this.showTimesheetModal = true
      },

      toggleColumnSelection(columnId) {
        if (this.buildingReport) return;

        // Se for PDF, não permite alterar colunas
        if (this.selectedExportFormat === 'pdf') return;

        const index = this.selectedColumns.indexOf(columnId);
        if (index > -1) {
          this.selectedColumns.splice(index, 1);
        } else {
          this.selectedColumns.push(columnId);
        }
      },

      isColumnDisabled(columnId) {
        // Se for PDF, todas as colunas ficam desabilitadas
        return this.selectedExportFormat === 'pdf' || this.selectedExportFormat === 'pdf_plus' || this.buildingReport;
      },

      updateValueColumnsBasedOnShowHourlyRate() {
        if (this.showHourlyRate && (this.selectedHourlyRateOption === DUTY_VALUE_SOURCE_SCALE || this.selectedHourlyRateOption === DUTY_VALUE_SOURCE_USER_SCALE || this.selectedHourlyRateOption === DUTY_VALUE_SOURCE_USER_GROUP)) {
          if (!this.selectedColumns.includes('userHourlyRate')) this.selectedColumns.push('userHourlyRate');
          if (!this.selectedColumns.includes('payment')) this.selectedColumns.push('payment');

          // Se for PDF, adiciona totalDecimalDuration também
          if (this.selectedExportFormat === 'pdf' && !this.selectedColumns.includes('totalDecimalDuration')) {
            this.selectedColumns.push('totalDecimalDuration');
          }
        } else {
          this.selectedColumns = this.selectedColumns.filter(id => id !== 'userHourlyRate' && id !== 'payment');

          // Se for PDF e desmarcar valor hora, remove totalDecimalDuration
          if (this.selectedExportFormat === 'pdf') {
            this.selectedColumns = this.selectedColumns.filter(id => id !== 'totalDecimalDuration');
          }
        }
        if (this.selectedExportFormat === 'pdf') this.applyPDFColumnRestrictions();
        if (this.selectedExportFormat === 'pdf_plus') this.applyPDFPlusColumnRestrictions();
      },

      async generateTimesheet ()
      {
        if (!!this.buildingReport === true) return false


        const isValid = Array.isArray(this.dateRange) && this.dateRange.length === 2 && isValidDate(this.dateRange[0]) && isValidDate(this.dateRange[1])

        if (!isValid) {
          return this.showMessage('Atenção!', 'Selecione o período do registro de check-in/check-out')
        }



        if (this.selectedColumns.length === 0) {
            this.showMessage('Atenção!', 'Selecione pelo menos uma coluna para o relatório.');
            return false;
        }

        if (this.selectedScales.length === 0) {
            this.showMessage('Atenção!', 'Selecione pelo menos uma escala para o relatório.');
            return false;
        }


        this.buildingReport = true

        try
        {
          const selectedUsersIds = this.users.filter(user => user.checked).map(user => user.uid).join(',')
          const simularValue = 'false';
          const horaValue = this.showHourlyRate ? 'true' : 'false';
          const selectedHourlyRate = this.showHourlyRate ? this.selectedHourlyRateOption : 'false';
          const columnsParameter = `/${this.selectedColumns.join(',')}`;
          const scalesParameter = this.selectedScales.length > 0 ? `/${this.selectedScales.join(',')}` : '/all';

          const checkEndpoint = `checktimesheet/${selectedUsersIds}/${this.groupID}/${this.dateRange[0]}/${this.dateRange[1]}/${simularValue}${scalesParameter}`

          const response = await apiCheckReportStatus(checkEndpoint)

          if (response.code !== 1) {
            this.showMessage(response.title, response.message)
          } else {
            if (this.selectedExportFormat === 'pdf_plus') {
                     const pdfEndpoint = `timesheetpdfplus/${selectedUsersIds}/${this.groupID}/${this.dateRange[0]}/${this.dateRange[1]}/${simularValue}/${horaValue}/${selectedHourlyRate}${columnsParameter}${scalesParameter}`
                     const pdfResponse = await apiDownloadTimesheetPDF(pdfEndpoint, this.$store.state.app.userSession.userToken)

                     if (pdfResponse.code !== 1) {
                        this.showMessage('Erro', pdfResponse.message)
                     }
              } else if (this.selectedExportFormat === 'pdf') {
              const pdfEndpoint = `timesheetpdf/${selectedUsersIds}/${this.groupID}/${this.dateRange[0]}/${this.dateRange[1]}/${simularValue}/${horaValue}/${selectedHourlyRate}${columnsParameter}${scalesParameter}`
              const pdfResponse = await apiDownloadTimesheetPDF(pdfEndpoint, this.$store.state.app.userSession.userToken)

              if (pdfResponse.code !== 1) {
                this.showMessage('Erro', pdfResponse.message)
              }
            } else {
              const generateUrl = `timesheet/${selectedUsersIds}/${this.groupID}/${this.dateRange[0]}/${this.dateRange[1]}/${simularValue}/${horaValue}/${selectedHourlyRate}${columnsParameter}${scalesParameter}`
              apiOpenReport(generateUrl)
            }
          }
        }
        catch (error)
        {
          this.showMessage('Erro!', 'Não foi possível gerar o relatório. Por favor, atualize a página e tente novamente ou fale com o nosso suporte.')
        }

        this.buildingReport = false
      },

      onClickUser (user)
      {
        if (!!this.buildingReport === true) return false

        const { uid: userID } = user

        this.users = this.users.map(userObject => (userObject.uid === userID ? { ...userObject, checked: !userObject.checked } : userObject))

        this.checkboxAllUsers = this.users.filter(userObject => userObject.checked === true).length === this.users.length

      },

      onAllCheckboxClick ()
      {
        if (!!this.buildingReport === true) return false

        this.checkboxAllUsers = !this.checkboxAllUsers

        this.users = this.users.map(userObject => ({ ...userObject, checked: this.checkboxAllUsers }))
      },

      onShowHourlyRateClick ()
      {
        if (!!this.buildingReport === true) return false

        this.showHourlyRate = !this.showHourlyRate;

        // Se desmarcou o checkbox, limpa a seleção do tipo de valor por hora
        if (!this.showHourlyRate) {
          this.selectedHourlyRateOption = 'scale';
        }

        this.updateValueColumnsBasedOnShowHourlyRate();
      },

      onHourlyRateOptionChange (value) {
        this.selectedHourlyRateOption = value;
        this.updateValueColumnsBasedOnShowHourlyRate();
      },

      onExportFormatChange (value) {
        if (!!this.buildingReport === true) return false;
            this.selectedExportFormat = value;

          if (value === 'pdf') {
              this.applyPDFColumnRestrictions();
          } else if (value === 'pdf_plus') {
              this.applyPDFPlusColumnRestrictions();
          }
      },

      applyPDFPlusColumnRestrictions() {
            const detailedColumns = [
                'period', 'groupName', 'userName', 'userCRM',
                'data', 'escala', 'coordsEntry', 'coordsExit',
                'plannedEntry', 'plannedExit', 'plannedDuration',
                'actualEntry', 'actualExit', 'totalDuration',
                'deviceEntry', 'deviceExit'
            ];

            if (this.showHourlyRate) {
                detailedColumns.push('userHourlyRate');
                detailedColumns.push('totalDecimalDuration');
                detailedColumns.push('payment');
            }

            this.selectedColumns = detailedColumns;
        },

      applyPDFColumnRestrictions() {
        // Colunas obrigatórias para PDF
        const pdfColumns = [
          // Dados do Plantonista (sem telefone)
          'period',
          'groupName',
          'userName',
          'userCRM',
          'userCPF',
          'userAccount',
          'userEmail',

          // Dados do Plantão
          'data',
          'escala',
          'actualEntry',
          'actualExit',
          'totalDuration',
        ];

        // Se mostrar valor hora, adiciona duração decimal
        if (this.showHourlyRate) {
          pdfColumns.push('totalDecimalDuration');
          pdfColumns.push('userHourlyRate');
          pdfColumns.push('payment');
        }

        this.selectedColumns = pdfColumns;
      },

      openScalesSelection() {
        this.showScalesModal = true;
      },

      closeScalesModal() {
        this.showScalesModal = false;
      },

      toggleScale(scaleID) {
        const index = this.selectedScales.indexOf(scaleID);
        if (index > -1) {
          this.selectedScales.splice(index, 1);
        } else {
          this.selectedScales.push(scaleID);
        }
      },

      toggleAllScales() {
        if (this.allScalesSelected) {
          this.selectedScales = [];
        } else {
          this.selectedScales = this.availableScales.map(scale => scale.scaleID);
        }
      },

      initializeSelectedScales() {
        // Por padrão, todas as escalas são selecionadas
        if (this.availableScales.length > 0 && this.selectedScales.length === 0) {
          this.selectedScales = this.availableScales.map(scale => scale.scaleID);
        }
      },
    },
  }

</script>

<style lang="scss">

  .modalTimesheetField--showHourlyRate
  {
    font-size: 0;

    .csLabel {
      display: inline-block;
      height: auto;

      line-height: 15px;
    }

    .sosCheckboxLabel {
      color: #495057;
      font-size: 15px !important;
      font-weight: 500;
      padding-left: 7px !important;
    }
  }

  .fieldTimesheetMonthYear {
    width: 100%;

    .mx-datepicker {
      width: 100%;
    }
  }

  .modalTimesheetField--columns {
    margin-bottom: 20px;
  }

  .csFields--columns-selection {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .column-group {
    margin-bottom: 15px;
  }

  .column-group-title {
    font-size: 1.1em;
    font-weight: bold;
    margin-bottom: 10px;
    color: #333;
    border-bottom: 1px solid #eee;
    padding-bottom: 5px;
  }

  .column-checkbox-group {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 10px;
  }

  .scale-selection-display {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 15px;
    background: #fff;
    border: 1px solid #ced4da;
    border-radius: 4px;
    cursor: pointer;
    transition: border-color 0.15s ease-in-out;
    min-height: 42px;

    &:hover:not(.is-disabled):not(.is-empty) {
      border-color: rgba(229, 66, 69, 0.7);
    }

    &.is-empty {
      border-color: rgba(220, 53, 69, 0.7);
      background: #fff5f5;

      &:hover:not(.is-disabled) {
        border-color: rgba(200, 35, 51, 0.7);
      }
    }

    &.is-disabled {
      background: #e9ecef;
      cursor: not-allowed;
      opacity: 0.6;
    }
  }

  .scale-names-container {
    flex: 1;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px;
    font-size: 14px;
    color: #495057;
  }

  .empty-scales-text {
    color: #dc3545;
    font-weight: 500;
    font-style: italic;
  }

  .scale-name {
    font-weight: 500;
  }

  .separator {
    color: #6c757d;
  }

  .more-scales {
    color: #007bff;
    font-weight: 600;
    margin-left: 4px;
  }

  .all-scales-text {
    color: #28a745;
    font-weight: 600;
    font-style: italic;
  }

  .scale-selection-icon {
    margin-left: 10px;
    color: #6c757d;
    font-size: 20px;
    line-height: 1;
  }

  .scale-selection-info {
    display: flex;
    align-items: center;
    gap: 15px;
    padding: 10px;
    background: #f8f9fa;
    border-radius: 4px;
  }

  .selected-scales-count {
    font-size: 14px;
    color: #495057;
    font-weight: 500;
  }

  .btn-select-scales {
    padding: 8px 16px;
    background: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: background 0.2s;

    &:hover:not(:disabled) {
      background: #0056b3;
    }

    &:disabled {
      background: #ccc;
      cursor: not-allowed;
    }
  }

  .scales-selection-container {
    padding: 10px;
  }

  .scales-header {
    margin-bottom: 15px;
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;
  }

  .scales-list {
    max-height: 400px;
    overflow-y: auto;
  }

  .scale-item {
    padding: 8px 0;
    border-bottom: 1px solid #f0f0f0;

    &:last-child {
      border-bottom: none;
    }
  }

</style>

<style lang="scss" scoped>

  .err {
    color: indianred;
    font-size: 15px;
    font-weight: 400;
    line-height: 1;
  }

  .modalTimesheetField {
    position: relative;
    width: 100%;
  }

  .modalTimesheetGenerateButton {
    position: absolute;
    right: 6px;
    top: 5px;
  }

  .inline-block {
    display: inline-block;
    vertical-align: middle;
  }

  .usersCountArea {
    line-height: 0;
  }

  .usersCount {
    font-size: 15px;
    line-height: 1;
  }

  .footerLeft {
    width: 50%;

    text-align: left;
  }

  .footerRight {
    width: 50%;
    text-align: right;
  }

</style>
